module.exports = __webpack_public_path__ + "resources/ani-applaud.e906a673419362c5.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/applaud-ani/img/ani-applaud.png
// module id = 716
// module chunks = 0 1 2